import { AdPlacement } from "@/components/ads/AdPlacement";
import { m } from "@/paraglide/messages";
import { DataSizeTool } from "../components/DataSizeTool";
import { DsBreadcrumb } from "../components/DsBreadcrumb";
import { DsExplainer } from "../components/DsExplainer";

export function DataSizePage() {
  return (
    <div className="relative">
      <div className="pointer-events-none absolute inset-0 gradient-mesh" />
      <div className="relative mx-auto max-w-3xl px-4 py-12 sm:px-6 lg:px-8">
        <DsBreadcrumb />

        <header className="mb-8 mt-6">
          <h1 className="font-display text-3xl font-bold tracking-tight sm:text-4xl">
            {m.ds_h1()}
          </h1>
          <p className="mt-3 leading-relaxed text-muted-foreground">
            {m.ds_intro()}
          </p>
        </header>

        <DataSizeTool />

        <DsExplainer
          howTo={m.ds_howto()}
          faqs={[
            { q: m.ds_faq1_q(), a: m.ds_faq1_a() },
            { q: m.ds_faq2_q(), a: m.ds_faq2_a() },
            { q: m.ds_faq3_q(), a: m.ds_faq3_a() },
            { q: m.ds_faq4_q(), a: m.ds_faq4_a() },
          ]}
        />

        <AdPlacement className="mt-10" />
      </div>
    </div>
  );
}
